import { gql } from '@apollo/client';
import SPECIFICATION from './SPECIFICATION';
const MODELS = gql `
  ${SPECIFICATION}
  fragment MySpecifications on UserNode {
    modelSpecifications(
      search: $search
      tags_TagId: $tags
      orderBy: $orderBy
      first: $first
      after: $after
      isActive: $isActive
      state: $state
      statusId: $statusId
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...SpecificationFragment
        }
      }
    }
  }
`;
export default MODELS;
